import React from 'react';
import AnimationWrapper from 'swag-client-common/components/animation-wrapper';
import { Button } from 'swag-client-common/components/ui/button';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import { redirectWithSavingScroll } from 'swag-client-common/utils/tricks';
import classes from './automation-section.scss';
export const AutomationSection = () => {
  return /*#__PURE__*/React.createElement(AnimationWrapper, {
    offset: 200,
    className: classes.container
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.titleWrapper
  }, /*#__PURE__*/React.createElement("h3", null, "Swag", /*#__PURE__*/React.createElement("br", null), "Automation"), /*#__PURE__*/React.createElement("p", null, "Never miss a chance to connect by using our API to automatically distribute swag for employees, clients and leads. Together, we\u2019re making swag smart."), /*#__PURE__*/React.createElement(Button, {
    className: classes.button,
    type: "primary",
    size: "normal",
    onClick: redirectWithSavingScroll(APP_ROUTES.AUTOMATION)
  }, "Find Out More")), /*#__PURE__*/React.createElement("div", {
    className: classes.banner
  })));
};